import ConsentPurposeList from './List'
import ConsentPurposeShow from './Show'
import ConsentPurposeCreate from './Create'
import ConsentPurposeEdit from './Edit'
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined'

export default {
    icon: PrivacyTipOutlinedIcon,
    list: ConsentPurposeList,
    show: ConsentPurposeShow,
    create: ConsentPurposeCreate,
    edit: ConsentPurposeEdit
}